import * as Sentry from "@sentry/capacitor";
import * as SentryReact from "@sentry/react";
import { resolveMobileSentryConfig } from "./sentry.config";

const sentryConfig = resolveMobileSentryConfig({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV,
  mode: import.meta.env.MODE,
});

if (sentryConfig.dsn) {
  Sentry.init(
    {
      dsn: sentryConfig.dsn,
      sendDefaultPii: true,
      environment: sentryConfig.environment,
      debug: import.meta.env.DEV,
      beforeSend: (event) => {
        if (event.exception?.values?.length) {
          const exception = event.exception.values[0];
          if (
            exception.type?.includes("CannotDeliverBroadcastException") ||
            exception.value?.includes("CannotDeliverBroadcastException")
          ) {
            return null;
          }
        }
        return event;
      },
    },
    SentryReact.init,
  );
} else if (sentryConfig.reason === "invalid") {
  console.error(
    "Sentry is disabled because VITE_SENTRY_DSN is malformed. Remove surrounding quotes and provide a valid https:// DSN.",
  );
} else if (import.meta.env.DEV) {
  console.warn("Sentry is disabled because VITE_SENTRY_DSN is not set.");
}

export { Sentry };
